import { Select } from '../../input';
import { Error } from '../../error';

export const ProxyInput = ({ params, onChange, errors }) => (
  <>
    <Select
      label="Proxy"
      value={params.proxy}
      onChange={(val) => onChange('proxy', val)}
      style={{ width: 120 }}
      choices={[
        ['none', 'None ($0.01/GB)'],
        ['datacenter', 'Datacenter ($0.01/GB)'],
        ['residential_cdp', 'Residential CDP, do not load assets ($8/GB)'],
        ['residential_cdp_assets', 'Residential CDP, load assets ($8.50/GB)'],
        ['auto', 'Automatically select'],
      ]}
    />
    <Error message={errors?.proxy} />
  </>
);
